import './App.css';
import {BrowserRouter, Routes, Route} from "react-router-dom";

import React from "react";
import Build from "./components";


function App() {
  return (
      <BrowserRouter>
          <div className="container-fluid">
            <Route path={"/"} component = {Build} />
           
          </div>
      </BrowserRouter>

  );
}

export default App;
